import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'ramda/src/isEmpty';
import { AppActions } from '~/actions';
import { redirect } from 'react-router-dom';
import './Landing.scss';

const Landing = () => {
    const user = useSelector((state) => state.app.user);
    const authenticated = !isEmpty(user) && user.id > 0;
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [buttonText, setButtonText] = React.useState('Login');
    const dispatch = useDispatch();

    useEffect(() => {
        // Handle URL parameter if needed
        if (!authenticated) {
            redirect('/library/training');
        }
    }, [authenticated]);

    const handleLogin = () => {
        setButtonText('Logging in...');
        dispatch(AppActions.loginRequest({ email:username, password }));
    };

    const passwordReset = () => {
        console.log('Password reset clicked'); // Add this
        try {
            dispatch(AppActions.modalRequest({ type: 'Reset Password' }));
        } catch (error) {
            console.error('Error dispatching modalRequest:', error);
        }
        console.log('AppActions:', AppActions); // Check what actions are available
    };

  return (
    <div className="landing-container">
      <div className="landing-background">
        <div className="landing-form-container">
          <img 
            src="/images/tula/LiveTula-Hrz-White.png"
            alt="OLA Logo"
            className="landing-logo"
          />
          <div className="landing-motto">
            WE HELP YOU THRIVE
          </div>
          
          <div className="landing-input-container">
            <input
            type="text"
                placeholder="Username"
                className="landing-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
            />
            <input
                type="password"
                placeholder="Password"
                className="landing-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <button className="landing-button" onClick={handleLogin}>{ buttonText }</button>
            <div className="landing-forgot-password" onClick={passwordReset}>Forgot Password?</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
